import { Model } from "@vuex-orm/core"

export default class Photo extends Model {
  static entity = "photos"

  static fields() {
    return {
      id: this.string(""),
      name: this.string(""),
      pos: this.number(0),
      folder: this.string(""),
    }
  }

  id!: string
  name!: string
  pos!: number
  folder!: string
}
